export const columns: any[] = [
  {
    title: '工单编号',
    dataIndex: 'issueNumber',
    align: 'left',
    width: 200,
  },
  {
    title: '事件',
    dataIndex: 'eventList',
    align: 'left',
  },
  {
    title: '工单状态',
    dataIndex: 'issueStatus',
    align: 'left',
  },
  {
    title: '工单创建时间',
    dataIndex: 'issueCreateTime',
    align: 'left',
  },
  {
    title: '工单关闭时间',
    dataIndex: 'issueEndTime',
    align: 'left',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    align: 'left',
  },
];
